import { searchIntegrationNumber, setupCall } from 'store/actions/call'
import { AppUrls } from 'common/AppUrls'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'

export const useIntegration = () => {
    const location = useLocation()
    const { integration } = useSelector((state) => state.profile)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!integration || location.pathname !== AppUrls.callerInsights) return

        const urlParams = new URLSearchParams(location.search)
        const number = urlParams.get('number')

        if (number) {
            dispatch(setupCall({ number }))
            dispatch(searchIntegrationNumber({ number, driver: integration.key }))
        }
        // eslint-disable-next-line
    }, [location.pathname, location.search, integration])
}
